import React from 'react';
import { OrdemDeServicoFormData } from '../../types/ordemServico';
import { Receipt, DollarSign } from 'lucide-react';

interface OsFormTabDespesasProps {
  formData: OrdemDeServicoFormData;
  setFormData: React.Dispatch<React.SetStateAction<OrdemDeServicoFormData>>;
}

export const OsFormTabDespesas: React.FC<OsFormTabDespesasProps> = ({
  formData,
  setFormData,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value, type } = e.target;
    let finalValue: any = value;

    if (type === 'number') {
      finalValue = value === '' ? 0 : parseFloat(value);
    }

    setFormData((prev) => ({ ...prev, [name]: finalValue }));
  };

  return (
    <div className="space-y-4 p-4 bg-slate-50 border border-slate-200/80 rounded-xl">
      <div className="flex items-center gap-2 border-b border-slate-200 pb-2">
        <Receipt className="w-4 h-4 text-red-600" />
        <h4 className="text-xs font-bold uppercase tracking-wider text-slate-700">
          Despesas Extras da Viagem
        </h4>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-12 gap-4">
        <div className="sm:col-span-8">
          <label className="block text-xs font-bold text-slate-700 uppercase mb-1">
            Descrição das Despesas
          </label>
          <input
            type="text"
            name="despesas"
            value={formData.despesas}
            onChange={handleChange}
            placeholder="Ex: Pedágio, combustível extra, alimentação..."
            className="w-full border border-slate-300 rounded-lg px-3 py-2 text-sm text-slate-800 focus:ring-2 focus:ring-red-500 outline-none"
          />
        </div>

        <div className="sm:col-span-4">
          <label className="block text-xs font-bold text-slate-700 uppercase mb-1 flex items-center gap-1">
            <DollarSign className="w-3.5 h-3.5 text-rose-600" />
            Valor da Despesa (R$)
          </label>
          <input
            type="number"
            step="0.01"
            min="0"
            name="valor_despesa"
            value={formData.valor_despesa}
            onChange={handleChange}
            className="w-full border border-slate-300 rounded-lg px-3 py-2 text-sm font-bold text-rose-700 focus:ring-2 focus:ring-red-500 outline-none"
          />
        </div>
      </div>
    </div>
  );
};
